import React, { useEffect } from 'react';
import { useSensitiveCitiesContext } from 'src/contexts/sensitive-cities.context';
import { actionTypes } from 'src/ducks/sensitive-cities.duck';
import { getSensitiveCitiesStatus } from 'src/selectors/sensitive-cities.selector';
import SensitiveCitiesView from './sensitive-cities-list.view';

const SensitiveCities: React.FC = () => {
  const { state, actions } = useSensitiveCitiesContext();

  useEffect(() => {
    actions.listGET();
  }, [actions]);

  return (
    <SensitiveCitiesView
      loading={
        getSensitiveCitiesStatus(state, actionTypes.SENSITIVE_CITIES_FETCH).fetching
      }
      data={state.list}
    />
  );
};

export default SensitiveCities;
